import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { ThemeId } from '../../styles/themes';
import ThemePickerGrid from './ThemePickerGrid';

const ThemeSelectorModal: React.FC = () => {
  const { showThemeSelector, setShowThemeSelector, themeId, setTheme, availableThemes } = useTheme();

  const handleSelect = (id: ThemeId) => setTheme(id);

  return (
    <AnimatePresence>
      {showThemeSelector && (
        <motion.div
          className="theme-modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setShowThemeSelector(false)}
          style={{ zIndex: 9998 }}
        >
          <motion.div
            className="theme-modal glow-card"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <button type="button" className="theme-modal__close" onClick={() => setShowThemeSelector(false)} aria-label="Kapat">
              <X size={22} />
            </button>
            <h2 className="theme-modal__title">Tema ayarları</h2>
            <p className="theme-modal__subtitle">Görünümü kişiselleştirin — seçim otomatik kaydedilir.</p>
            <ThemePickerGrid themes={availableThemes} selectedId={themeId} onSelect={handleSelect} />
            <div className="theme-modal__actions">
              <motion.button
                type="button"
                className="theme-modal__btn theme-modal__btn--primary"
                onClick={() => setShowThemeSelector(false)}
                whileTap={{ scale: 0.98 }}
              >
                Tamam
              </motion.button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ThemeSelectorModal;
